// =======================
// GENERIC RANGE FILTER (Price, Surface, etc.)
// =======================
document.addEventListener('DOMContentLoaded', function () {

    // Initialize all range filters
    const rangeFilters = document.querySelectorAll('.range-filter');
    console.log('Range filters found:', rangeFilters.length);

    rangeFilters.forEach(function (filterElement) {
        console.log('Initializing range filter:', filterElement.id, 'Type:', filterElement.dataset.filterType);
        initRangeFilter(filterElement);
    });

    function initRangeFilter(filterElement) {
        const filterId = filterElement.id;
        const filterType = filterElement.dataset.filterType;
        const toggle = filterElement.querySelector('.dropdown-toggle');
        const applyBtn = filterElement.querySelector('.range-apply-btn');
        const dropdownMenu = filterElement.querySelector('.dropdown-menu');
        const fromInput = filterElement.querySelector('.range-from-input');
        const toInput = filterElement.querySelector('.range-to-input');
        const fromColumn = filterElement.querySelector('[id$="FromColumn"]');
        const toColumn = filterElement.querySelector('[id$="ToColumn"]');
        const fromItems = filterElement.querySelectorAll('.range-from-item');

        let selectedFromValue = null;
        let selectedToValue = null;
        
        // Get all values from the FROM items
        const allValues = Array.from(fromItems)
            .map(item => item.dataset.value)
            .filter(val => val !== '')
            .map(val => parseInt(val))
            .sort((a, b) => a - b);

        // Get formatter function based on filter type
        const formatter = getFormatter(filterType);
        const shortFormatter = getShortFormatter(filterType);
        const defaultLabel = toggle.textContent.trim();

        // Initially show only FROM column
        showFromColumn();

        // Close dropdown when clicking "VEDI RISULTATI"
        if (applyBtn) {
            applyBtn.addEventListener('click', function () {
                if (dropdownMenu) {
                    dropdownMenu.classList.remove('show');
                }
                if (toggle) {
                    toggle.classList.remove('show');
                    toggle.setAttribute('aria-expanded', 'false');

                    const arrow = toggle.querySelector('.arrow');
                    if (arrow) {
                        arrow.classList.remove('active');
                    }
                }
            });
        }

        // Handle FROM input click
        if (fromInput) {
            fromInput.addEventListener('click', function (e) {
                e.stopPropagation();
                showFromColumn();
            });
        }

        // Handle TO input click
        if (toInput) {
            toInput.addEventListener('click', function (e) {
                e.stopPropagation();
                if (selectedFromValue !== null) {
                    showToColumn();
                }
            });
        }

        // Handle FROM items click
        fromItems.forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const value = this.dataset.value;

                fromItems.forEach(function (i) {
                    i.classList.remove('active');
                });

                this.classList.add('active');

                if (value === '') {
                    selectedFromValue = null;
                    fromInput.value = '';
                    toInput.value = '';
                    selectedToValue = null;
                    updateToggleText();
                    showFromColumn();
                } else {
                    const newFromValue = parseInt(value);

                    if (selectedToValue !== null && newFromValue >= selectedToValue) {
                        selectedToValue = null;
                        toInput.value = '';
                    }

                    selectedFromValue = newFromValue;
                    fromInput.value = formatter(value);

                    populateToColumn(selectedFromValue);
                    showToColumn();

                    updateToggleText();
                }
            });
        });

        function showFromColumn() {
            if (fromColumn) {
                fromColumn.classList.remove('d-none');
            }
            if (toColumn) {
                toColumn.classList.add('d-none');
            }
            if (fromInput) {
                fromInput.classList.add('active');
            }
            if (toInput) {
                toInput.classList.remove('active');
            }
        }

        function showToColumn() {
            if (fromColumn) {
                fromColumn.classList.add('d-none');
            }
            if (toColumn) {
                toColumn.classList.remove('d-none');
            }
            if (fromInput) {
                fromInput.classList.remove('active');
            }
            if (toInput) {
                toInput.classList.add('active');
            }
        }

        function populateToColumn(fromValue) {
            if (!toColumn) return;

            const filteredValues = allValues.filter(function (val) {
                return val > fromValue;
            });

            toColumn.innerHTML = '';

            // Add "Indifferente" option
            const indifferenteDiv = document.createElement('div');
            indifferenteDiv.className = 'px-3 py-2 text-end';
            const indifferenteLink = document.createElement('a');
            indifferenteLink.href = '#';
            indifferenteLink.className = 'd-block py-2 text-decoration-none range-to-item';
            indifferenteLink.dataset.value = '';
            indifferenteLink.textContent = 'Indifferente';
            indifferenteLink.addEventListener('click', handleToItemClick);
            indifferenteDiv.appendChild(indifferenteLink);
            toColumn.appendChild(indifferenteDiv);

            // Add filtered values
            filteredValues.forEach(function (val) {
                const div = document.createElement('div');
                div.className = 'px-3 py-2 text-end';
                const link = document.createElement('a');
                link.href = '#';
                link.className = 'd-block py-2 text-decoration-none range-to-item';
                link.dataset.value = val.toString();
                link.innerHTML = formatter(val.toString());
                link.addEventListener('click', handleToItemClick);
                div.appendChild(link);
                toColumn.appendChild(div);
            });
        }

        function handleToItemClick(e) {
            e.preventDefault();
            e.stopPropagation();

            const value = this.dataset.value;

            const allToItems = toColumn.querySelectorAll('.range-to-item');
            allToItems.forEach(function (i) {
                i.classList.remove('active');
            });

            this.classList.add('active');

            if (value === '') {
                selectedToValue = null;
                toInput.value = '';
            } else {
                selectedToValue = parseInt(value);
                toInput.value = formatter(value);
            }

            updateToggleText();
        }

        function updateToggleText() {
            if (!selectedFromValue && !selectedToValue) {
                setToggleText(defaultLabel);
            } else if (selectedFromValue && !selectedToValue) {
                setToggleText(shortFormatter(selectedFromValue) + ' - Qualsiasi');
            } else if (!selectedFromValue && selectedToValue) {
                setToggleText('0 - ' + shortFormatter(selectedToValue));
            } else {
                setToggleText(shortFormatter(selectedFromValue) + ' - ' + shortFormatter(selectedToValue));
            }
        }

        function setToggleText(text) {
            if (toggle) {
                const arrow = toggle.querySelector('.arrow');
                if (arrow) {
                    arrow.remove();
                }

                toggle.textContent = text;

                // Add or remove 'selected' class based on whether a selection is active
                if (text !== defaultLabel) {
                    toggle.classList.add('selected');
                } else {
                    toggle.classList.remove('selected');
                }

                toggle.insertAdjacentHTML('beforeend', "<div class='arrow arrow--smallest arrow--down arrow--white ms-1'><span></span><span></span></div>");
            }
        }
    }

    // Formatter functions based on filter type
    function getFormatter(type) {
        switch (type) {
            case 'price':
                return function (value) {
                    const num = parseInt(value);
                    return num.toLocaleString('it-IT').replace(/\./g, '.') + ' €';
                };
            case 'surface':
                return function (value) {
                    return value + ' m²';
                };
            default:
                return function (value) {
                    return value;
                };
        }
    }

    function getShortFormatter(type) {
        switch (type) {
            case 'price':
                return function (value) {
                    const num = parseInt(value);
                    if (num >= 1000) {
                        return (num / 1000) + 'k €';
                    }
                    return num + ' €';
                };
            case 'surface':
                return function (value) {
                    return value + ' m²';
                };
            default:
                return function (value) {
                    return value;
                };
        }
    }
});
